var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ListQuestion } from "./list-question";
import { QuestionType } from "app/shared/models/question-type";
var MultipleChoiceQuestion = /** @class */ (function (_super) {
    __extends(MultipleChoiceQuestion, _super);
    function MultipleChoiceQuestion() {
        var _this = _super.call(this) || this;
        _this.type = QuestionType.MultipleChoice;
        return _this;
    }
    Object.defineProperty(MultipleChoiceQuestion.prototype, "answer", {
        get: function () {
            return this._answer;
        },
        set: function (v) {
            this._answer = v;
        },
        enumerable: true,
        configurable: true
    });
    MultipleChoiceQuestion.prototype.hasAnswer = function (ans) {
        return this.isAnswer(ans);
    };
    Object.defineProperty(MultipleChoiceQuestion.prototype, "isFilledOut", {
        get: function () {
            return this._answer != null;
        },
        enumerable: true,
        configurable: true
    });
    MultipleChoiceQuestion.prototype.isAnswer = function (ans) {
        if (this.answer) {
            return this.answer.id === ans.id;
        }
        return false;
    };
    MultipleChoiceQuestion.prototype.setSavedAnswer = function (answer, labels) {
        this.answer = labels.find(function (l) { return l.id == answer; });
    };
    Object.defineProperty(MultipleChoiceQuestion.prototype, "answerDisplayText", {
        get: function () {
            if (!this.answer) {
                return "";
            }
            return this.answer.label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultipleChoiceQuestion.prototype, "answerForSave", {
        get: function () {
            if (!this._answer) {
                return null;
            }
            return this._answer.id;
        },
        enumerable: true,
        configurable: true
    });
    return MultipleChoiceQuestion;
}(ListQuestion));
export { MultipleChoiceQuestion };



// WEBPACK FOOTER //
// ./src/app/shared/models/multiple-choice-question.ts.pre-build-optimizer.js